import React, { useContext, useState } from 'react';
import './Registration.css'
import { FaGoogle } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';
import { toast } from 'react-toastify';
import useTitle from '../../hooks/useTittle';

const Registration = () => {
    useTitle('Create Account');

    const { createUser } = useContext(AuthContext)
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleRegister = (event) => {
        setError(null);
        event.preventDefault();
        const form = event.target;
        const userName = form.name.value
        const userEmail = form.email.value;
        const userPassword = form.password.value;
        const userConfirmPassword = form.confirmPassword.value;
        if (userPassword !== userConfirmPassword) {
            setError("Password didn't match");
            form.password.value = '';
            form.confirmPassword.value = '';
            return;
        }

        console.log(userEmail, userPassword, userName);
        createUser(userEmail, userPassword)
            .then(result => {
                const user = result.user;
                const currentUser = {
                    email: user.email
                }
                fetch('https://salma-kitchen-server.vercel.app/jwt', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(currentUser)
                })
                    .then(res => res.json())
                    .then(data => {
                        localStorage.setItem('smkToken', data.token);
                        toast("Registration Successful!");
                        navigate('/');
                    })
            })
            .catch(error => setError(error));
        form.reset()
    }



    return (
        <div className='reg-background py-24'>
            <div className='reg-background-overlay'></div>
            <form onSubmit={handleRegister} className='px-3'>
                <div className="card sm:w-full md:w-2/5 bg-base-100 shadow-xl mx-auto">
                    <div className="card-body">
                        <h1 className='text-center my-12 md:text-4xl font-bold'>Create Your Account</h1>

                        {
                            error ?
                                <div className="alert alert-error shadow-lg">
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                        <span>{error}</span>
                                    </div>
                                </div>
                                :
                                <></>

                        }

                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Your name?</span>
                            </label>
                            <input required name='name' type="text" placeholder="Type your full name" className="input input-bordered w-full" />
                        </div>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Your e-mail?</span>
                            </label>
                            <input required name='email' type="email" placeholder="Type your e-mail" className="input input-bordered w-full" />
                        </div>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Password</span>
                            </label>
                            <input required name='password' type="password" placeholder="Type a strong Password" className="input input-bordered w-full" />
                        </div>
                        <div className="form-control w-full">
                            <label className="label">
                                <span className="label-text  md:text-2xl">Confirm Password</span>
                            </label>
                            <input required name='confirmPassword' type="password" placeholder="Re-type Password" className="input input-bordered w-full" />
                        </div>
                        <div className='mt-3'>
                            <button type='submit' className="btn w-full">Submit</button>
                        </div>
                        <div className="divider">OR</div>
                        <h1 className='text-center'>Continue with</h1>
                        <div className='flex justify-around px-6'>
                            <button className="btn btn-outline md:px-24 md:text-3xl"><FaGoogle /></button>
                        </div>
                        <div className="divider">Already have an account?</div>
                        <Link to={'/login'}><h1 className='underline text-center text-2xl'>Go to Log in</h1></Link>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Registration;